import { z } from "zod";

export const editProductSchema = z.object({
  name: z.string().min(5, "Product name"),
  price: z.string(),
  category: z.string(),
  sub_category: z.string(),
  description: z.string().min(10, "Product Description!"),
  benefits: z
    .string()
    .min(5, "Each benefit must be at least 5 characters long"),
  thumbnail: z.string(),
});

export type EditProductFormData = z.infer<typeof editProductSchema>;

export const updateProductSchema = z.object({
  name: z.string().min(5, "Product name"),
  price: z.number(),
  category: z.string(),
  sub_category: z.string(),
  description: z.string().min(10, "Product Description!"),
  benefits: z.array(
    z.string().min(5, "Each benefit must be at least 5 characters long"),
  ),
  thumbnail: z.string(),
});

export type UpdateFormData = z.infer<typeof updateProductSchema>;
